/**
 * API-клиент: метки клиентов (BUG-138).
 */
import api from './api';

export type AssignedBy = 'manual' | 'auto' | 'system';

export interface AutoRule {
  trigger:
    | 'promocode_used'
    | 'orders_count_gte'
    | 'first_order'
    | 'inactive_days'
    | 'birthday_month'
    | 'total_spent_gte';
  params: Record<string, unknown>;
}

export interface ClientTag {
  id: number;
  name: string;
  slug: string;
  color: string;
  description: string | null;
  is_system: boolean;
  auto_rule: AutoRule | null;
  users_count: number | null;
  created_at: string;
  updated_at: string;
}

export interface ClientTagCreate {
  name: string;
  slug: string;
  color?: string;
  description?: string | null;
  auto_rule?: AutoRule | null;
}

export interface ClientTagUpdate {
  name?: string;
  color?: string;
  description?: string | null;
  auto_rule?: AutoRule | null;
}

export interface UserTag {
  id: number;
  tag_id: number;
  tag: ClientTag;
  assigned_at: string;
  assigned_by: AssignedBy;
  assigned_by_admin_id: number | null;
  reason: string | null;
}

// ── Tags CRUD ─────────────────────────────────────────────

export async function listClientTags(withCounts = true): Promise<ClientTag[]> {
  const r = await api.get('/admin/client-tags', { params: { with_counts: withCounts } });
  return r.data;
}

export async function createClientTag(body: ClientTagCreate): Promise<ClientTag> {
  const r = await api.post('/admin/client-tags', body);
  return r.data;
}

export async function updateClientTag(id: number, body: ClientTagUpdate): Promise<ClientTag> {
  const r = await api.patch(`/admin/client-tags/${id}`, body);
  return r.data;
}

export async function deleteClientTag(id: number): Promise<void> {
  await api.delete(`/admin/client-tags/${id}`);
}

// ── Users / tags ──────────────────────────────────────────

export async function listUserTags(userId: number): Promise<UserTag[]> {
  const r = await api.get(`/admin/clients/${userId}/tags`);
  return r.data;
}

export async function assignUserTag(
  userId: number,
  tagId: number,
  reason?: string
): Promise<UserTag> {
  const r = await api.post(`/admin/clients/${userId}/tags`, { tag_id: tagId, reason });
  return r.data;
}

export async function unassignUserTag(userId: number, tagId: number): Promise<void> {
  await api.delete(`/admin/clients/${userId}/tags/${tagId}`);
}

export async function listUsersByTag(tagId: number, skip = 0, limit = 100): Promise<number[]> {
  const r = await api.get(`/admin/client-tags/${tagId}/users`, { params: { skip, limit } });
  return r.data;
}

export async function getTagsMapForUsers(
  userIds: number[]
): Promise<Record<number, UserTag[]>> {
  if (!userIds.length) return {};
  const r = await api.post('/admin/clients/tags-map', userIds);
  return r.data;
}

// ── Trigger params helper ─────────────────────────────────

export const TRIGGER_PARAMS: Record<AutoRule['trigger'], string[]> = {
  promocode_used: ['promo_code'],
  orders_count_gte: ['count'],
  first_order: [],
  inactive_days: ['days'],
  birthday_month: [],
  total_spent_gte: ['amount'],
};

export const TRIGGER_LABEL: Record<AutoRule['trigger'], string> = {
  promocode_used: 'Использован промокод',
  orders_count_gte: 'N заказов и более',
  first_order: 'Первый заказ',
  inactive_days: 'Неактивен N дней',
  birthday_month: 'Месяц дня рождения',
  total_spent_gte: 'Сумма покупок ≥',
};
